<div class="container openAccount">
  <div class="row">
    <div class="col-md-2">
      <p>Laft Nav</p>
    </div>
    <div class="col-md-5">
      <p>About the Customer</p>
    </div>
    <div class="col-md-5">
      <div class="row">
        <div class="col-md-12">
          <f-data-card>            
            <h3> Tickets </h3>
            <p>No open tickets for this customer.</p>
            <a href="javascript:void">Go to Assist Case Management</a>
          </f-data-card>
        </div>
      </div>
    </div>
  </div>


</div>